<script>
  import fileTemplateState from "../../stores/fileTemplateJsonData"
  import cursorPosition from "../../stores/cursorPosition"
  import { onDestroy } from "svelte"

  let index = 0
  let timer = setInterval(() => {
    if (index < $fileTemplateState.footerArray.length) {
      $fileTemplateState.notifyFooter = $fileTemplateState.footerArray[index]
      index++
    } else {
      index = 0
    }
  }, 3000)
  onDestroy(() => {
    clearInterval(timer)
  })
</script>

<div class="flex w-full items-center justify-between bg-[#000000cc] py-2 pr-6 pl-24">
  <div class="flex items-center justify-between gap-9">
    <div class=" flex items-center gap-3 text-xs text-gray-500 md:text-base">
      <i class="fa-solid fa-square-dashed" />
      <h1 class="font-bold tracking-wide text-gray-500">{$fileTemplateState.baseImageInfo.width ? $fileTemplateState.baseImageInfo.width : 0} X {$fileTemplateState.baseImageInfo.height ? $fileTemplateState.baseImageInfo.height : 0} Px</h1>
    </div>
    <div class="flex items-center gap-3 text-xs text-gray-500 md:text-base">
      <i class="fa-solid fa-arrow-pointer" />
      <div>
        <h1 class="w-28 font-bold tracking-wide text-gray-500">{$cursorPosition.x}, {$cursorPosition.y}</h1>
      </div>
    </div>
    <div class=" flex items-center gap-3">
      <h1 class="select-none font-bold tracking-wide text-gray-500">{Math.round($fileTemplateState.scale * 100)}%</h1>
      <button
        on:click={() => {
          if ($fileTemplateState.scale > 1 && $fileTemplateState.scale < 3) {
            $fileTemplateState.scale = $fileTemplateState.scale - 0.1
          }
        }}
      >
        <i class="fa-solid fa-minus text-gray-500" />
      </button>
      <input min="1" max="2.5" step="0.1" bind:value={$fileTemplateState.scale} type="range" class="cursor-pointer outline-none" />
      <button
        on:click={() => {
          if ($fileTemplateState.scale < 2.5) {
            $fileTemplateState.scale = $fileTemplateState.scale + 0.1
          }
        }}
      >
        <i class="fa-solid fa-plus text-gray-500" />
      </button>
    </div>
  </div>
  <h1 class=" block text-xs font-bold tracking-wide text-gray-500 md:text-base">
    {$fileTemplateState.notifyFooter ? $fileTemplateState.notifyFooter : "FileTemplate Editor.!!!"}
  </h1>
</div>
